import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_ENCOUNTER_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
  // v3: performerId is now nullable (null for unmatched IMPORTED encounters)
  3: (oldDoc) => ({ ...oldDoc, performerId: oldDoc.performerId ?? null }),
  // v4: attempted compound index — data unchanged
  4: (oldDoc) => oldDoc,
  // v5: removed compound index (RxDB requires maxLength on all fields; performerId is nullable
  //     without maxLength). ["status", "date"] covers the triage-queue query sufficiently.
  5: (oldDoc) => oldDoc,
  // v6: added maxLength: 256 to performerId — schema-only, data unchanged
  6: (oldDoc) => oldDoc,
  // v7: added dicomStudyId (optional) — default null for existing docs
  7: (oldDoc) => ({ ...oldDoc, dicomStudyId: null }),
  // v8: added DICOM demographics + operator — default null for existing docs
  8: (oldDoc) => ({
    ...oldDoc,
    patientDob: null,
    patientGender: null,
    operatorName: null,
  }),
  // v9: added deviceSerialNumber — default null; the next pull refills it
  9: (oldDoc) => ({ ...oldDoc, deviceSerialNumber: null }),
  10: (oldDoc) => ({ ...oldDoc, programId: null }),
  // v11: patientId renamed to elephantPatientId (PNE-598). The value is the
  // same ElephantOS patient uuid, so it moves across rather than resetting.
  11: ({ patientId, ...rest }) => ({
    ...rest,
    elephantPatientId: patientId ?? null,
  }),
};
